import { FieldLabel } from '@/ui/FieldLabel'
import { FieldRadioContent, FieldRadioGroup, FieldRadioItem } from '@/ui/FieldRadioGroup'
import Icon from '@/ui/Icon/Icon'
import { ModalContext, ModalTrigger } from '@/ui/Modal/Modalv2/Modal'

import dynamic from 'next/dynamic'
import { translatePriceModifier } from '../../product.utils'
import { useProductTracking } from '../../ProductTracking/ProductTracking'
import { OptionFieldProps } from '../ProductConfigurator.types'

const EnvelopePrintingModal = dynamic(
  () =>
    import('@/domains/product/shared/EnvelopePrintingModal/EnvelopePrintingModal').then((m) => m.EnvelopePrintingModal),
  { ssr: false }
)

const AutomatedEnvelopePrintingModal = dynamic(
  () =>
    import('@/domains/product/shared/AutomatedEnvelopePrintingModal/AutomatedEnvelopePrintingModal').then(
      (m) => m.AutomatedEnvelopePrintingModal
    ),
  { ssr: false }
)

export function EnvelopePrintingField({
  options,
  priceModifier,
  onChange,
  onMouseEnter = () => {},
  showInfo,
  isAutomatedEnvelope,
}: OptionFieldProps) {
  const selected = options.find((opt) => opt.selected)

  const { track } = useProductTracking()

  return (
    <ModalContext>
      <FieldRadioGroup data-testid="envelope-printing-field">
        <FieldLabel data-testid="envelope-printing-label">
          <FieldLabel.Title>Printing options:</FieldLabel.Title>
          <FieldLabel.Text>{selected?.name}</FieldLabel.Text>
          {showInfo ? (
            <ModalTrigger asChild>
              <FieldLabel.Trigger
                onClick={() =>
                  track({
                    type: 'ctaClicked',
                    payload: { element_clicked: 'info modal icon', reason: 'Envelope printing' },
                  })
                }
              >
                <Icon name="info" size="sm" />
              </FieldLabel.Trigger>
            </ModalTrigger>
          ) : null}
          {priceModifier ? <FieldLabel.Modifier>+${translatePriceModifier(priceModifier)}</FieldLabel.Modifier> : null}
        </FieldLabel>
        {options.length > 1 && (
          <FieldRadioContent orientation={'vertical'}>
            {options.map((option) => (
              <>
                <FieldRadioItem
                  key={option.valueId}
                  value={option.valueId || ''}
                  onClick={() => onChange(option.valueId)}
                  onMouseEnter={() => onMouseEnter(option.valueId)}
                  checked={option.selected}
                  disabled={option.forbidden}
                >
                  <FieldLabel>
                    <FieldLabel.Title>{option.name}</FieldLabel.Title>
                  </FieldLabel>
                </FieldRadioItem>
              </>
            ))}
          </FieldRadioContent>
        )}
      </FieldRadioGroup>
      {!isAutomatedEnvelope && <EnvelopePrintingModal />}
      {isAutomatedEnvelope && <AutomatedEnvelopePrintingModal />}
    </ModalContext>
  )
}
